<script setup lang="ts">
withDefaults(
  defineProps<{
    direction?: 'horizontal' | 'vertical';
  }>(),
  {
    direction: 'horizontal',
  },
);
</script>

<template>
  <div v-if="direction === 'horizontal'" :class="['bg-surface-border flex h-[1px] scale-y-50']"></div>
  <div v-else :class="['bg-surface-border flex w-[1px] scale-x-50']"></div>
</template>
